<span class="spinner set-spinner__location"></span>